<template>
    <ExtendedLayout
        :user="user"
        currentTab="activity-log"
    >

        <Table
            :headings="[
                __('admin::labels.event'),
                __('admin::labels.changes'),
                __('admin::labels.changed_by'),
                __('admin::labels.date'),
            ]"
            :paginator="paginator"
            :withFilters="false"
            :withActions="false"
        >

            <template #results>
                <tr v-for="activity in paginator.data" :key="activity.id">
                    <td class="!align-top py-4 !h-auto whitespace-nowrap">
                        {{ eventNames[activity.event] || activity.event }} <br>
                        <span v-if="activity.subject_type === 'App\\Models\\User'" class="italic">{{ __('admin::labels.core_data') }}</span>
                        <span v-if="activity.subject_type === 'App\\Models\\UserEmployment'" class="italic">{{ __('admin::labels.employment') }}: {{ companyOptions[activity.subject.company_id] || '—' }}</span>
                    </td>
                    <td
                        class="!align-top py-4 !h-auto whitespace-pre-line"
                    >
                        <span
                            v-html="generateChangeLog(activity)"
                            :class="[activity.show_full ? '' : 'line-clamp-2']"
                        />
                        <button
                            type="button"
                            @click="activity.show_full = true"
                            v-if="! activity.show_full && Object.keys(activity.properties.attributes).length > 2"
                            class="italic"
                        >
                            {{ __('admin::labels.show_all_n_changes', { count: Object.keys(activity.properties.attributes).length }) }}
                        </button>
                    </td>
                    <td class="!align-top py-4 !h-auto whitespace-nowrap">{{ activity.causer.name }}</td>
                    <td class="!text-left !align-top py-4 !h-auto whitespace-nowrap">{{ $datetime(activity.created_at) }}</td>
                </tr>
            </template>

        </Table>

    </ExtendedLayout>
</template>

<script>
import ExtendedLayout from '@A/Pages/Users/Edit';

export default {
    components: {
        ExtendedLayout,
    },
    props: {
        errors: Object,
        user: Object,
        paginator: Object,
        companyOptions: Object,
        roleOptions: Object,
        departmentOptions: Object,
    },
    data() {
        return {
            eventNames: {
                created: this.__('admin::activities.event_created'),
                updated: this.__('admin::activities.event_updated'),
                deleted: this.__('admin::activities.event_deleted'),
            },
            attributeNames: {
                'name': this.__('admin::labels.name'),
                'email': this.__('admin::labels.email'),
                'phone': this.__('admin::labels.phone'),
                'private_phone': this.__('admin::labels.private_phone'),
                'password': this.__('admin::labels.password'),
                'company_id': this.__('admin::labels.company'),
                'role': this.__('admin::labels.role'),
                'organization_level': this.__('admin::labels.organization_level'),
                'departments': this.__('admin::labels.departments'),
                'job_title': this.__('admin::labels.job_title'),
                'avatar_id': this.__('admin::labels.avatar'),
                'image_id': this.__('admin::labels.image'),
                'short_description': this.__('admin::labels.short_description'),
                'long_description': this.__('admin::labels.long_description'),
                'personal_identification_number': this.__('admin::labels.personal_identification_number'),
                'computer_serial_number': this.__('admin::labels.computer_serial_number'),
                'is_active': this.__('admin::labels.is_active'),
                'sync_with_gmail': this.__('admin::labels.sync_with_gmail'),
                'sync_with_wordpress': this.__('admin::labels.sync_with_wordpress'),
                'use_autoreply': this.__('admin::labels.use_autoreply'),
                'autoreply_subject': this.__('admin::labels.autoreply_subject'),
                'autoreply_body': this.__('admin::labels.autoreply_body'),
                'forward_email': this.__('admin::labels.forward_email'),
                'forward_email_to': this.__('admin::labels.forward_email_to'),
                'list_order': this.__('admin::labels.list_order'),
                'slack_user_id': this.__('admin::labels.slack_user_id'),
                'relatel_employee_id': this.__('admin::labels.relatel_employee_id'),
                'born_at': this.__('admin::labels.born_at'),
                'employed_at': this.__('admin::labels.employed_at'),
            },
            arrowSvg: '<svg xmlns="http://www.w3.org/2000/svg" class="inline-block h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>',
        };
    },
    methods: {
        generateChangeLog(activity) {
            let changes = activity.properties;
            let content = [];

            for (let attribute in changes.attributes) {
                let attributeName = this.attributeNames[attribute] || attribute;

                let values = [changes.old?.[attribute], changes.attributes[attribute]]
                    .map((x) => {
                        if (x === true) {
                            x = this.__('admin::labels.yes');
                        }
                        else if (x === false) {
                            x = this.__('admin::labels.no');
                        }
                        else if (x) {
                            if (attribute === 'company_id') {
                                x = this.companyOptions[x];
                            }
                            else if (attribute === 'role') {
                                x = this.roleOptions[x];
                            }
                            else if (attribute === 'departments') {
                                x = x.map((y) => this.departmentOptions[y] || y).join(', ');
                            }
                        }

                        return x || ('<i>' + this.__('admin::labels.empty') + '</i>');
                    });

                let line = `<strong>${attributeName}:</strong>`;

                if (activity.event === 'updated') {
                    line += ` ${values[0]} ${this.arrowSvg}`;
                }

                line += ` ${values[1]}`;

                content.push(line);
            }

            return content.join("\n");
        },
    },
}
</script>
